import { useState, useEffect } from "react"
import { Flex, Box, Heading, Text } from "@chakra-ui/react"
import ModeratorList from "./moderatorList"
import { useGlobalState } from "src/providers/globalState"
import Highlighter from "components/agenda/highlighter"
import FormattedTimeString from "components/agenda/formattedTimeString"
import RenderLink from "components/agenda/renderLink"

export default function Presentation(props) {
    const { site } = useGlobalState()
    const [moderators, setModerators] = useState([])
    const isSectionTitle = props.level && !props.children.length

    useEffect(() => {
        // combine roles with the same display_name
        let _groupedMoerators = []
        props.moderators.forEach(group => {
            if (_groupedMoerators.find(g => g.role.display_name === group.role.display_name)) {
                _groupedMoerators.find(g => g.role.display_name === group.role.display_name).users.push(...group.users)
            } else {
                _groupedMoerators.push(group)
            }
        })

        setModerators(_groupedMoerators)
    }, [props.moderators])

    const ConditionalLink = function ({ children }) {
        if (props.suppressLinks || !site?.meeting.isLive || props.title === "Break")
            return <Text as="span">{children}</Text>

        return (
            <RenderLink event={props} channelSlug={props.channelSlug} site={site}>
                {children}
            </RenderLink>
        )
    }

    return (
        <Box
            className={"program__presentation " + "program__presentation--level-" + props.level}
            mt={4}
            mb={props.level && !props.children.length ? 4 : 12}
        >
            <Flex align="baseline">
                {isSectionTitle && !props.params.on_demand ? (
                    <Text mr="4" mt={0} minW={70} color="#333">
                        <FormattedTimeString event={props} />
                    </Text>
                ) : null}

                <Box>
                    <Heading
                        className={"program__presentationTitle" + isSectionTitle ? " program__sectionTitle" : null}
                        as="h4"
                        fontFamily="heading"
                        size={props.level ? "sm" : "md"}
                        fontWeight={isSectionTitle ? "normal" : "600"}
                        mt="1"
                        mb="1"
                        color={props.level ? "#333" : props.color}
                    >
                        <ConditionalLink>
                            <Highlighter hit={!!props.searchValue} text={props.title} />
                        </ConditionalLink>
                    </Heading>
                    {props.description && (
                        <Text
                            className="program__presentationDescription"
                            fontSize={15}
                            lineHeight={1.2}
                            mt={1}
                            mb={3}
                            color={props.level ? "#333" : props.color}
                        >
                            <Highlighter hit={!!props.searchValue} text={props.description} />
                        </Text>
                    )}
                    {/*<Heading as="h4" size={ props.level ? 'sm' : 'md' } fontWeight={ props.level ? 'normal' : '600' } mt="1" mb="1" color={ props.level ? '#333' : "color2" }>{props.title}</Heading>*/}

                    {!props.params?.on_demand ? (
                        !props.children.length ? (
                            !props.level ? (
                                <Text mt={0} color={props.level ? "#333" : props.color}>
                                    <FormattedTimeString event={props} />
                                </Text>
                            ) : null
                        ) : null
                    ) : null}

                    {site.meeting?.showModerators &&
                        moderators.map(moderatorGroup => {
                            return <ModeratorList key={moderatorGroup.role.id} group={moderatorGroup} />
                        })}
                </Box>
            </Flex>

            {props.children.map((event, i) => {
                return (
                    <Presentation
                        key={i}
                        {...event}
                        level={props.level + 1}
                        type={props.type}
                        suppressLinks={props.suppressLinks}
                    />
                )
            })}
        </Box>
    )
}
